import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useTranslation } from 'react-i18next';

const FMCRegionWarningDialog = ({ open, onConfirm, onCancel }) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningAmberIcon sx={{ color: 'warning.main' }} />
          <Typography variant="h6">
            {t('calculator.fmcRegionWarning.title', 'Region Change Warning')}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('calculator.fmcRegionWarning.message', 
            'You are switching to a region where FMC product is not supported. FMC will be removed from your selection. Do you want to continue?')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          {t('common.cancel', 'Cancel')}
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained">
          {t('calculator.fmcRegionWarning.confirm', 'Change Region')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FMCRegionWarningDialog;